import Nullstack from 'nullstack';
export default function IconMovieOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-movie-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8 4h10a2 2 0 0 1 2 2v10m-.592 3.42c-.362 .359 -.859 .58 -1.408 .58h-12a2 2 0 0 1 -2 -2v-12c0 -.539 .213 -1.028 .56 -1.388"
  }), "   ", Nullstack.element("path", {
    d: "M8 8v12"
  }), "   ", Nullstack.element("path", {
    d: "M16 4v8m0 4v4"
  }), "   ", Nullstack.element("path", {
    d: "M4 8h4"
  }), "   ", Nullstack.element("path", {
    d: "M4 16h4"
  }), "   ", Nullstack.element("path", {
    d: "M4 12h8m4 0h4"
  }), "   ", Nullstack.element("path", {
    d: "M16 8h4"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}